export default {"src":"/_next/static/media/srg.31aa84e5.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};